import { render } from "./mnTrend.vue?vue&type=template&id=85325074&scoped=true"
import script from "./mnTrend.vue?vue&type=script&lang=js"
export * from "./mnTrend.vue?vue&type=script&lang=js"

import "./mnTrend.vue?vue&type=style&index=0&id=85325074&scoped=true&lang=css"

import exportComponent from "D:\\php\\php20260824_dianshang\\mall-son_dxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85325074"]])

export default __exports__